import { FieldKey } from '../../context/field-keys.js';
import { rentConversionRules } from '../../shared/conversion.js';
/**
 * Lease rent yearly <-> monthly conversion — the formula that today lives in 4 TS files + 2 JS
 * files (common-rate.ts, common-listener-helper.ts, term-calculator.js, ...). Built from the shared
 * {@link rentConversionRules} factory; this file just declares the lease pairs.
 *
 * UOM mirroring is intentionally left to the host (the two legacy code paths disagree on it).
 */
export { yearlyFromMonthlyRule, monthlyFromYearlyRule, rentConversionRules } from '../../shared/conversion.js';
export const BASE_RENT_PAIR = {
  idPrefix: 'lease.base-rent',
  monthly: FieldKey.BaseRentMonthly,
  yearly: FieldKey.BaseRentYearly
};
export const EFFECTIVE_RENT_PAIR = {
  idPrefix: 'lease.effective-rent',
  monthly: FieldKey.EffectiveRentMonthly,
  yearly: FieldKey.EffectiveRentYearly
};
export const ASKING_RENT_PAIR = {
  idPrefix: 'lease.asking-rent',
  monthly: FieldKey.AskingRentMonthly,
  yearly: FieldKey.AskingRentYearly
};
export const leaseRentConversionRules = [...rentConversionRules(BASE_RENT_PAIR), ...rentConversionRules(EFFECTIVE_RENT_PAIR), ...rentConversionRules(ASKING_RENT_PAIR)];
